import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { refreshSession } from '@/lib/api/client'
import { useAuth } from '@/lib/auth/AuthProvider'
import { reconnectWs } from '@/lib/ws/client'
import { useRealtime } from '@/lib/ws/useRealtime'
import { SessionEndingBanner } from './SessionEndingBanner'

export function AuthRealtime() {
  const { t } = useTranslation()
  const { status, reloadMe } = useAuth()
  const qc = useQueryClient()

  useRealtime(
    (event) => event === 'auth.permissions_changed' || event === 'PERMISSIONS_CHANGED',
    () => {
      void (async () => {
        await refreshSession().catch(() => false)
        await reloadMe().catch(() => undefined)
        reconnectWs()
        void qc.invalidateQueries()
        toast.info(t('auth.permissionsChanged.title'), { description: t('auth.permissionsChanged.body') })
      })()
    },
  )

  useEffect(() => {
    if (status !== 'authenticated') return
  }, [status])

  return <SessionEndingBanner />
}
